import domainConfig, { DomainMode } from "config/domainConfig";
import { ATTACHMENT_VARIANTS } from "data/products/attachments";
import {
  DOOR_WIDTH,
  doorCost,
  glassList36H,
  glassList42H,
  glassList48H,
  glassList48R,
  glassListOtherR,
} from "data/products/glassPanels";
import { resellerCatalog } from "data/products/resellerCatalog";
import { Attachment, Material, Pannel, Province } from "types/canvasTypes";

type AttachmentVariantMap = Record<Material, Attachment>;

export type CompanyCatalog = {
  doorWidth: number;
  doorCost: Map<Province, number>;
  glassPanels: {
    h36: Pannel[];
    h42: Pannel[];
    h48: Pannel[];
    r48: Pannel[];
    rOther: Pannel[];
  };
  attachments: AttachmentVariantMap;
};

export type CompanyRules = {
  nonDoorMaxGlassLength: number;
  doorMaxGlassLength: number;
  panelCombinationTolerancePerPanel: number;
  chalkLineDeductionMultiplier: number;
  defaultGapSize: number;
  pointEqualityThresholdPx: number;
};

export type CompanyAuthorization = {
  allowedEmailDomainSubstrings: string[];
  whitelist: string[];
};

export type CompanyConfig = {
  id: string;
  displayName: string;
  catalog: CompanyCatalog;
  rules: CompanyRules;
  authorization: CompanyAuthorization;
};

const baseCatalog: CompanyCatalog = {
  doorWidth: DOOR_WIDTH,
  doorCost,
  glassPanels: {
    h36: glassList36H,
    h42: glassList42H,
    h48: glassList48H,
    r48: glassList48R,
    rOther: glassListOtherR,
  },
  attachments: ATTACHMENT_VARIANTS as unknown as AttachmentVariantMap,
};

const baseRules: CompanyRules = {
  nonDoorMaxGlassLength: 73,
  doorMaxGlassLength: 69,
  panelCombinationTolerancePerPanel: 0.1,
  chalkLineDeductionMultiplier: 2,
  defaultGapSize: 1,
  pointEqualityThresholdPx: 5,
};

const adminWhitelist = [
  "george.andalaft@gmail.com",
  "hananne8@gmail.com",
  "desrosiers.daniel@gmx.com",
  "sales@etpmetals.com",
  "fuanne@glass-railing.com",
  "fuannegao25@gmail.com"
];

export const defaultCompanyConfig: CompanyConfig = {
  id: "default",
  displayName: "Default",
  catalog: baseCatalog,
  rules: baseRules,
  authorization: {
    allowedEmailDomainSubstrings: ["cloture-verre", "glass-railing"],
    whitelist: adminWhitelist,
  },
};

export const resellerCompanyConfig: CompanyConfig = {
  id: "reseller",
  displayName: "Reseller",
  catalog: resellerCatalog,
  rules: baseRules,
  authorization: {
    allowedEmailDomainSubstrings: ["glass-railing"],
    whitelist: adminWhitelist,
  },
};

export function getCompanyConfigByMode(mode: DomainMode): CompanyConfig {
  return mode === "reseller" ? resellerCompanyConfig : defaultCompanyConfig;
}

export function getActiveCompanyConfig(): CompanyConfig {
  return getCompanyConfigByMode(domainConfig.mode);
}
